import { missionId } from "utils/urls";

const headers = () => {
  return {
    "Content-Type": "application/json",
    "X-Forwarded-From": missionId,
  };
};

export const existingHeaders = headers();
